import { render, staticRenderFns } from "./rebateSetting.vue?vue&type=template&id=55129dbe&scoped=true&"
import script from "./rebateSetting.vue?vue&type=script&lang=js&"
export * from "./rebateSetting.vue?vue&type=script&lang=js&"
import style0 from "./rebateSetting.vue?vue&type=style&index=0&id=55129dbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55129dbe",
  null
  
)

export default component.exports